export const UOMData = {
  'Currency': [
    'EUR',
    'USD'
  ],
  'CurrencyRate': [
    'EUR/hr',
    'EUR/day',
    'EUR/year',
    'USD/hr',
    'USD/day',
    'USD/year'
  ],
  'Current': [
    'A'
  ],
  'Density': [
    'kg/m3',
    'g/cc'
  ],
  'Dynamic Viscosity': [
    'dyn/mm**2*s'
  ],
  'Energy': [
    'BTU',
    'kBTU',
    'cal',
    'kcal',
    'J',
    'kJ',
    'MJ',
    'Wh',
    'kWh',
    'MWh',
    'tep',
    'ktep'
  ],
  'EnergyRate': [
    'BTU/s',
    'BTU/min',
    'BTU/hr',
    'BTU/day',
    'kBTU/s',
    'kBTU/min',
    'kBTU/hr',
    'kBTU/day',
    'cal/s',
    'cal/min',
    'cal/hr',
    'cal/day',
    'kcal/s',
    'kcal/min',
    'kcal/hr',
    'kcal/day',
    'J/s',
    'J/min',
    'J/hr',
    'J/day',
    'kJ/s',
    'kJ/min',
    'kJ/hr',
    'kJ/day',
    'MJ/s',
    'MJ/min',
    'MJ/hr',
    'MJ/day',
    'tep/s',
    'tep/min',
    'tep/hr',
    'tep/day',
    'ktep/s',
    'ktep/min',
    'ktep/hr',
    'ktep/day',
    'Gcal/hr'
  ],
  'Energy/Mass': [
    'J/kg',
    'kJ/kg',
    'kcal/kg',
    'ktep/ktonne',
    'tep/ktonne'
  ],
  'Fraction': [
    '%',
    'fraction',
    'PPM'
  ],
  'Kinematic Viscosity': [
    'mm**2/s'
  ],
  'Mass': [
    'mg',
    'g',
    'kg',
    'lb',
    'tonne',
    'ktonne'
  ],
  'MassRate': [
    'g/s',
    'g/min',
    'g/hr',
    'kg/s',
    'kg/min',
    'kg/hr',
    'kg/day',
    'lb/s',
    'lb/min',
    'lb/hr',
    'lb/day',
    't/s',
    't/min',
    't/hr',
    't/day'
  ],
  'Mass/Mass': [
    't/ktonne',
    'mg/kg',
    'mg/g'
  ],
  'Power': [
    'W',
    'kW',
    'MW'
  ],
  'Pressure': [
    'atm',
    'bar',
    'mmHg',
    'mmH2O',
    'Pa',
    'kPa',
    'psi'
  ],
  'Temperature': [
    'celsius',
    'fahrenheit',
    'kelvin',
    'rankine'
  ],
  'Time': [
    's',
    'hr',
    'min',
    'day',
    'year'
  ],
  'Voltage': [
    'V',
    'kV'
  ],
  'Volume': [
    'cc',
    'm3',
    'ml',
    'litre',
    'bbl'
  ],
  'VolumeRate': [
    'cc/s',
    'm3/s',
    'm3/min',
    'm3/hr',
    'ml/s',
    'l/s',
    'l/min',
    'l/hr',
    'bbl/hr',
    'bbl/day',
    'bbl/year'
  ],
  'Dimensionless': [
    'Dimensionless'
  ]
};
